/* BCF C2 urgency: sale countdown, held-price timer, low stock, viewers, arrival date.
   No network calls. Every localStorage access is guarded; without storage the
   deadlines are page-load + duration. */
(function (root) {
  'use strict';

  var TZ = 'America/Chicago';

  // ---- arrival date (pure) -------------------------------------------------
  function chicagoParts(now) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric' });
    var o = {};
    f.formatToParts(now).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day };
  }
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      var w = d.getUTCDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }
  // Order is placed "today" (Chicago); dispatch = next business day; arrival = dispatch + 3 business days.
  // Returns the calendar date as a Date at 12:00 UTC (format it with timeZone UTC).
  function arrivalDate(now) {
    var c = chicagoParts(now || new Date());
    var today = new Date(Date.UTC(c.y, c.m - 1, c.d, 12));
    return addBusinessDays(addBusinessDays(today, 1), 3);
  }
  function formatArrival(date) {
    return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }).format(date);
  }

  // ---- deadlines -------------------------------------------------------------
  function readStore(key) {
    try { var v = Number(root.localStorage.getItem(key)); return isFinite(v) && v > 0 ? v : 0; } catch (e) { return 0; }
  }
  function writeStore(key, v) {
    try { root.localStorage.setItem(key, String(v)); } catch (e) { /* storage blocked */ }
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Returns a function giving ms remaining; resets to a full period at zero.
  function makeDeadline(key, periodMs) {
    var deadline = readStore(key);
    var now = Date.now();
    if (!deadline || deadline <= now || deadline > now + periodMs) { deadline = now + periodMs; writeStore(key, deadline); }
    return function () {
      var left = deadline - Date.now();
      if (left <= 0) { deadline = Date.now() + periodMs; writeStore(key, deadline); left = periodMs; }
      return left;
    };
  }

  function startCountdown(el, opts) {
    var hours = (opts && opts.hours) || 3;
    var els = [].concat(el && el.length !== undefined && !el.nodeType ? [].slice.call(el) : el).filter(Boolean);
    var remaining = makeDeadline('bcf_c2_deadline', hours * 3600000);
    function tick() {
      var s = Math.ceil(remaining() / 1000);
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      els.forEach(function (c) {
        var a = c.querySelector('[data-c2-hh]'), b = c.querySelector('[data-c2-mm]'), d = c.querySelector('[data-c2-ss]');
        if (a) a.textContent = pad(h);
        if (b) b.textContent = pad(m);
        if (d) d.textContent = pad(sec);
      });
    }
    tick();
    var id = setInterval(tick, 500);
    return function stop() { clearInterval(id); };
  }

  function startHold(el, opts) {
    var minutes = (opts && opts.minutes) || 10;
    var remaining = makeDeadline('bcf_c2_hold', minutes * 60000);
    function tick() {
      var s = Math.ceil(remaining() / 1000);
      el.textContent = 'Sale price held for ' + pad(Math.floor(s / 60)) + ':' + pad(s % 60);
    }
    tick();
    var id = setInterval(tick, 500);
    return function stop() { clearInterval(id); };
  }

  // ---- page wiring -----------------------------------------------------------
  function init() {
    var doc = root.document;
    var pdp = doc.querySelector('[data-c2-pdp]');
    if (!pdp) return;

    // The sale bar is lifted outside [data-c2-pdp] on ?view=c2: query the whole document.
    var clocks = doc.querySelectorAll('[data-c2-countdown]');
    if (clocks.length) startCountdown(clocks, { hours: Number(clocks[0].getAttribute('data-hours')) || 3 });

    var hold = doc.querySelector('[data-c2-hold]');
    if (hold) startHold(hold, { minutes: Number(pdp.getAttribute('data-c2-hold-minutes')) || 10 });

    var arrive = doc.querySelector('[data-c2-arrive]');
    if (arrive) arrive.textContent = formatArrival(arrivalDate(new Date()));

    var spec = doc.querySelector('[data-c2-stock-spec]');
    function syncSpec() {
      if (!spec) return;
      var len = pdp.querySelector('[data-c2-length][aria-pressed="true"]');
      var w = spec.getAttribute('data-mm');
      var parts = [];
      if (len) parts.push(len.getAttribute('data-c2-length') + '″');
      if (w) parts.push(w + ' mm');
      spec.textContent = parts.join(' · ');
    }
    syncSpec();
    doc.addEventListener('bcf:c2-offer-change', syncSpec);
    doc.addEventListener('bcf:variant-change', syncSpec);
  }

  var api = { arrivalDate: arrivalDate, formatArrival: formatArrival, startCountdown: startCountdown, startHold: startHold, init: init };
  root.BCFC2Urgency = api;
  if (root.document) {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', init);
    else init();
  }
})(typeof window !== 'undefined' ? window : globalThis);
